import type { HostResponseCodeDto } from "../../types/HostResponseCodeDto";
import type { HostResponseCodeEntity } from "../../types/HostResponseCodeEntity";

export const HostResponseCodeEntityToDto = ({ ...rest }: Readonly<HostResponseCodeEntity>): HostResponseCodeDto => {
    return { ...rest };
};
